import checkmark from './checkmark_icon.svg';
import './checkmark_icon.scss';
import { vfIconSimpleExtender } from '../icon/icon.js';


/**
 * checkmark Icon
 *
 * @data {"attrs": {"class": "vf-icon-large"}}
 * @styleguide components.icons.checkmark
 */
export const vfCheckmarkIcon = vfIconSimpleExtender('checkmark', checkmark);
